module.exports = __webpack_public_path__ + "media/src/images/usr_txt_1-cf5c36aeaf8dbafd399d66331f4fd215.png";